import { render, staticRenderFns } from "./giveAway.vue?vue&type=template&id=bfd7999a"
import script from "./giveAway.vue?vue&type=script&lang=js"
export * from "./giveAway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports